import {
  EuiPanel,
  EuiStat,
  EuiFlexItem,
  EuiIcon,
  EuiSpacer,
  EuiFlexGrid,
  EuiTitle,
  EuiLoadingSpinner,
  EuiLoadingChart,
  EuiButton,
  EuiHorizontalRule,
  EuiEmptyPrompt,
} from "@elastic/eui";
import { Chart, BarSeries, Axis, Settings } from "@elastic/charts";
import { AreaSeries, ScaleType } from "@elastic/charts";
import "@elastic/charts/dist/theme_light.css";
import React, { useState, Fragment, useEffect } from "react";
import StatsService from "../services/stats-service";
import { EuiDatePicker, EuiDatePickerRange } from "@elastic/eui";
import { MdOutlinePhoneCallback } from "react-icons/md";
import { HiArrowUpRight } from "react-icons/hi2";
import { MdPhoneInTalk } from "react-icons/md";
import { BiTimer } from "react-icons/bi";
import { LineSeries } from "@elastic/charts";
import moment from "moment";
import { CurveType } from "@elastic/charts";
import BauhausAdhoc from "./BauhausAdHoc";
import BauhausInAdHoc from "./BauhausInAdHoc";

const Dashboard = () => {
  const [accessPannelErrored, setAccessPanelErrored] = useState(false);

  const [startDate, setStartDate] = useState(moment().add(-24, "h"));
  const [endDate, setEndDate] = useState(moment());

  const [totalCalls, setTotalCalls] = useState();
  const [totalCallsLoading, setTotalCallsLoading] = useState(true);

  const [totalAttendedCalls, setTotalAttendedCalls] = useState();
  const [totalAbandonCalls, setTotalAbandonCalls] = useState();
  const [totalTimeoutCalls, setTotalTimeoutCalls] = useState();

  const [asr, setAsr] = useState();
  const [asrLoading, setAsrLoading] = useState(true);

  const [aht, setAht] = useState();
  const [ahtLoading, setAhtLoading] = useState(true);

  const [art, setArt] = useState();
  const [artLoading, setArtLoading] = useState(true);

  const [callsByQueue, setCallsByQueue] = useState(false);
  const [callsByQueueLoading, setCallsByQueueLoading] = useState(true);

  const [callsByQueueHourly, setCallsByQueueHourly] = useState(false);
  const [callsByQueueLoadingHourly, setCallsByQueueHourlyLoading] =
    useState(true);

  const [avgsByQueue, setAvgsByQueue] = useState(false);
  const [avgsByQueueLoading, setAvgsByQueueLoading] = useState(true);

  const [avgsByTrame, setAvgsByTrame] = useState(false);
  const [avgsByTrameLoading, setAvgsByTrameLoading] = useState(true);

  const [callsByAgent, setCallsByAgent] = useState(false);
  const [callsByAgentLoading, setCallsByAgentLoading] = useState(true);

  const [attendedByAgent, setAttendedByAgent] = useState(false);
  const [attendedByAgentLoading, setAttendedByAgentLoading] = useState(true);

  const [filterApplied, setFilterApplied] = useState(false);

  const [confirmedStartDate, setConfirmedStartDate] = useState(startDate);
  const [confirmedEndDate, setConfirmedEndDate] = useState(endDate);

  const filterClicked = () => {
    setFilterApplied(true);
    setCallsByQueueLoading(true);
    setCallsByQueueHourlyLoading(true);
    setAvgsByQueueLoading(true);
    setAvgsByTrameLoading(true);
    setCallsByAgentLoading(true);
    setAttendedByAgentLoading(true);
    setTotalCallsLoading(true);
    setAsrLoading(true);
    setAhtLoading(true);
    setArtLoading(true);

    setConfirmedStartDate(startDate);
    setConfirmedEndDate(endDate);

    const token = sessionStorage.getItem("krakenT");
    const initDate = startDate.toISOString();
    const endedDate = endDate.toISOString();

    // First Graph - Ammount calls by Queue
    StatsService.getCallsByQueue(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setCallsByQueue(callsToPush);
        setTotalCalls(response.data.message.totalCalls);
        setTotalAttendedCalls(response.data.message.totalAttended);
        setTotalAbandonCalls(response.data.message.totalAbandon);
        setTotalTimeoutCalls(response.data.message.totalTimeout);

        setTotalCallsLoading(false);
        setCallsByQueueLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });

    // Graph debajo - Amount calls by hour
    StatsService.getCallsByQueueHourly(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setCallsByQueueHourly(callsToPush);
        setCallsByQueueHourlyLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });

    // Arriba derecha - AVGs by queue
    StatsService.getAvgsByQueue(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setAsr(response.data.message.asr);
        setAsrLoading(false);

        setAht(response.data.message.avgDurationTime);
        setAhtLoading(false);

        setArt(response.data.message.avgRingingTime);
        setArtLoading(false);

        setAvgsByQueue(callsToPush);
        setAvgsByQueueLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });

    // Abajo derecha - AVGs by queue
    StatsService.getAvgsByTrame(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setAvgsByTrame(callsToPush);
        setAvgsByTrameLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // Abajo izquierda - Calls by agent
    StatsService.getCallsByAgent(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.agents;
        const callsToPush = [];
        for (let bucket of buckets) {
          callsToPush.push({ x: bucket.name, y: bucket.quantity });
        }
        setCallsByAgent(callsToPush);
        setCallsByAgentLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // Abajo izquierda - Calls by agent
    StatsService.getCallsByAgent(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.agentData) {
            callsToPush.push({ x: key, y: code.quantity, g: code.name });
          }
        }
        setCallsByAgent(callsToPush);
        setCallsByAgentLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // Abajo derecha - Attended by agent
    StatsService.getAttendedByAgent(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          callsToPush.push({ x: bucket.name, y: bucket.stats.value });
        }

        setAttendedByAgent(callsToPush);
        setAttendedByAgentLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const token = sessionStorage.getItem("krakenT");
    const initDate = startDate.toISOString();
    const endedDate = endDate.toISOString();

    // First Graph - Ammount calls by Queue
    StatsService.getCallsByQueue(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setCallsByQueue(callsToPush);
        setTotalCalls(response.data.message.totalCalls);
        setTotalAttendedCalls(response.data.message.totalAttended);
        setTotalAbandonCalls(response.data.message.totalAbandon);
        setTotalTimeoutCalls(response.data.message.totalTimeout);
        setTotalCallsLoading(false);
        setCallsByQueueLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setAccessPanelErrored(true);
      });

    // Graph debajo - Amount calls by hour
    StatsService.getCallsByQueueHourly(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setCallsByQueueHourly(callsToPush);
        setCallsByQueueHourlyLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });

    // Arriba derecha - AVGs by queue
    StatsService.getAvgsByQueue(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setAsr(response.data.message.asr);
        setAsrLoading(false);

        setAht(response.data.message.avgDurationTime);
        setAhtLoading(false);

        setArt(response.data.message.avgRingingTime);
        setArtLoading(false);

        setAvgsByQueue(callsToPush);
        setAvgsByQueueLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });

    // Abajo derecha - AVGs by queue
    StatsService.getAvgsByTrame(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.stats) {
            callsToPush.push({ x: key, y: code.value, g: code.name });
          }
        }
        setAvgsByTrame(callsToPush);
        setAvgsByTrameLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });

    // Abajo izquierda - Calls by agent
    StatsService.getCallsByAgent(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          const key = bucket.name;
          for (let code of bucket.agentData) {
            callsToPush.push({ x: key, y: code.quantity, g: code.name });
          }
        }
        setCallsByAgent(callsToPush);
        setCallsByAgentLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // Abajo derecha - Attended by agent
    StatsService.getAttendedByAgent(token, initDate, endedDate)
      .then((response) => {
        const buckets = response.data.message.queues;
        const callsToPush = [];
        for (let bucket of buckets) {
          callsToPush.push({ x: bucket.name, y: bucket.stats.value });
        }

        setAttendedByAgent(callsToPush);
        setAttendedByAgentLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div style={{ width: "100%", marginRight: 10 }}>
      {accessPannelErrored ? (
        <EuiEmptyPrompt
          iconType="alert"
          color="danger"
          title={<h2>Unable to load your dashboards</h2>}
          body={
            <p>
              There was an error loading the Dashboard application. Contact your
              administrator for help support@astroline.com.
            </p>
          }
        />
      ) : (
        <>
          <Fragment>
            {localStorage.getItem("CN") === "Bauhaus España" ? (
              <BauhausInAdHoc
                startDate={confirmedStartDate.toISOString()}
                endDate={confirmedEndDate.toISOString()}
              />
            ) : (
              <div>
                <EuiFlexGrid columns={4} responsive={false}>
                  <EuiFlexItem style={{ height: 10, fontSize: 16 }}>
                    <EuiPanel>
                      <div style={{ display: "flex" }}>
                        <div>
                          <EuiStat
                            title={
                              totalCallsLoading ? (
                                <div>
                                  <EuiLoadingSpinner size="xl" />
                                </div>
                              ) : (
                                <div>
                                  <span>
                                    <MdOutlinePhoneCallback
                                      style={{ marginBottom: -5 }}
                                    />
                                  </span>
                                  <span> {totalCalls}</span>
                                </div>
                              )
                            }
                            description="Total calls"
                            titleColor="#7334A2"
                            textAlign="right"
                          >
                            <EuiSpacer size="s" />
                          </EuiStat>
                        </div>
                        <div
                          style={{
                            marginRight: 0,
                            marginLeft: "auto",
                          }}
                        >
                          {/* Total Calls:{" "}
                        <b style={{ color: "#7334A2" }}>{totalCalls}</b>
                        <br></br> */}
                          Attended:{" "}
                          <b style={{ color: "#81D4AE" }}>
                            {totalAttendedCalls}
                          </b>
                          <EuiSpacer size="xs"></EuiSpacer>
                          Abandon:{" "}
                          <b style={{ color: "#FEC514" }}>
                            {totalAbandonCalls}
                          </b>
                          <EuiSpacer size="xs"></EuiSpacer>
                          Timeout:{" "}
                          <b style={{ color: "#BD271E" }}>
                            {totalTimeoutCalls}
                          </b>
                          <EuiSpacer size="xs"></EuiSpacer>
                        </div>
                      </div>
                    </EuiPanel>
                  </EuiFlexItem>
                  <EuiFlexItem>
                    <EuiPanel>
                      <EuiStat
                        title={
                          asrLoading ? (
                            <div>
                              <EuiLoadingSpinner size="xl" />
                            </div>
                          ) : (
                            <div>
                              <span>
                                <HiArrowUpRight style={{ marginBottom: -3 }} />
                              </span>
                              <span> {asr}%</span>
                            </div>
                          )
                        }
                        description="Answer Seizure Ratio"
                        titleColor="#81D4AE"
                        textAlign="right"
                      >
                        <EuiSpacer size="s" />
                      </EuiStat>
                    </EuiPanel>
                  </EuiFlexItem>
                  <EuiFlexItem>
                    <EuiPanel>
                      <EuiStat
                        title={
                          ahtLoading ? (
                            <div>
                              <EuiLoadingSpinner size="xl" />
                            </div>
                          ) : (
                            <div>
                              <div>
                                <span>
                                  <BiTimer style={{ marginBottom: -3 }} />
                                </span>
                                <span> {aht}</span>
                              </div>
                            </div>
                          )
                        }
                        description="Average Handle Time"
                        titleColor="#7334A2"
                        textAlign="right"
                      >
                        <EuiSpacer size="s" />
                      </EuiStat>
                    </EuiPanel>
                  </EuiFlexItem>
                  <EuiFlexItem>
                    <EuiPanel>
                      <EuiStat
                        title={
                          artLoading ? (
                            <div>
                              <EuiLoadingSpinner size="xl" />
                            </div>
                          ) : (
                            <div>
                              <div>
                                <span>
                                  <MdPhoneInTalk style={{ marginBottom: -3 }} />
                                </span>
                                <span> {art}</span>
                              </div>
                            </div>
                          )
                        }
                        description="Average Ringing Time"
                        titleColor="#81D4AE"
                        textAlign="right"
                      >
                        <EuiSpacer size="s" />
                      </EuiStat>
                    </EuiPanel>
                  </EuiFlexItem>
                </EuiFlexGrid>
              </div>
            )}

            <div style={{ marginTop: 50 }}>
              <div style={{ display: "flex" }}>
                <div>
                  <EuiTitle size="l">
                    <h1>
                      {" "}
                      <EuiIcon type="graphApp" size="xl" />{" "}
                      {filterApplied ? (
                        <>Operations history</>
                      ) : (
                        <>Day's operation</>
                      )}
                    </h1>
                  </EuiTitle>
                </div>
                <div
                  style={{
                    marginRight: 0,
                    marginLeft: "auto",
                    display: "flex",
                  }}
                >
                  <EuiDatePickerRange
                    isInvalid={startDate > endDate}
                    startDateControl={
                      <EuiDatePicker
                        selected={startDate}
                        onChange={(date) => date && setStartDate(date)}
                        startDate={startDate}
                        endDate={endDate}
                        aria-label="Start date"
                        showTimeSelect
                      />
                    }
                    endDateControl={
                      <EuiDatePicker
                        selected={endDate}
                        onChange={(date) => date && setEndDate(date)}
                        startDate={startDate}
                        endDate={endDate}
                        aria-label="End date"
                        showTimeSelect
                      />
                    }
                  />
                  &nbsp;
                  <EuiButton
                    fill
                    iconType="lensApp"
                    onClick={() => {
                      filterClicked();
                    }}
                  >
                    Filter
                  </EuiButton>
                </div>
              </div>
              <EuiSpacer />
              <EuiHorizontalRule
                margin="none"
                style={{ height: 2, marginRight: 10 }}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <EuiFlexGrid columns={2} responsive={true}>
                <EuiFlexItem>
                  <div style={{ widht: "100%", height: "18vh" }}>
                    <EuiIcon type="indexPatternApp" size="l" />
                    &nbsp;&nbsp;
                    <b>Calls by Queue</b>
                    {callsByQueueLoading ? (
                      <div style={{ marginTop: "6vh", marginLeft: "50%" }}>
                        <EuiLoadingChart size="m" mono />
                      </div>
                    ) : (
                      <Chart>
                        <Settings
                          showLegend
                          showLegendExtra
                          legendPosition={"right"}
                        />
                        <BarSeries
                          id="bars"
                          name="Amount"
                          xScaleType="ordinal"
                          xAccessor="x"
                          yAccessors={["y"]}
                          stackAccessors={["x"]}
                          splitSeriesAccessors={["g"]}
                          data={callsByQueue}
                        />
                        <Axis
                          title={"Queue"}
                          id="bottom-axis"
                          position="bottom"
                        />
                        <Axis
                          title={"Calls"}
                          id="left-axis"
                          position="left"
                          showGridLines
                        />
                      </Chart>
                    )}
                  </div>
                </EuiFlexItem>
                <EuiFlexItem>
                  <div style={{ widht: "100%", height: "18vh" }}>
                    <EuiIcon type="indexPatternApp" size="l" />
                    &nbsp;&nbsp;
                    <b>AVGs by Queue</b>
                    {avgsByQueueLoading ? (
                      <div style={{ marginTop: "6vh", marginLeft: "50%" }}>
                        <EuiLoadingChart size="m" mono />
                      </div>
                    ) : (
                      <Chart>
                        <Settings
                          showLegend
                          showLegendExtra
                          legendPosition={"right"}
                        />
                        <BarSeries
                          id="bars2"
                          displayValueSettings={true}
                          xScaleType={ScaleType.Linear}
                          yScaleType={ScaleType.Linear}
                          xAccessor="x"
                          yAccessors={["y"]}
                          stackAccessors={["x"]}
                          splitSeriesAccessors={["g"]}
                          data={avgsByQueue}
                        />
                        <Axis
                          title={"Queue"}
                          id="bottom-axis"
                          position="bottom"
                        />
                        <Axis
                          title={"AVGs"}
                          id="left-axis"
                          position="left"
                          showGridLines
                        />
                      </Chart>
                    )}
                  </div>
                </EuiFlexItem>
                <EuiFlexItem>
                  <div
                    style={{ widht: "100%", height: "18vh", marginTop: "2vh" }}
                  >
                    <EuiIcon type="machineLearningApp" size="l" />
                    &nbsp;&nbsp;
                    <b>Calls by Trame</b>
                    {callsByQueueLoadingHourly ? (
                      <div style={{ marginTop: "6vh", marginLeft: "50%" }}>
                        <EuiLoadingChart size="m" mono />
                      </div>
                    ) : (
                      <Chart>
                        <Settings
                          showLegend
                          showLegendExtra
                          legendPosition={"right"}
                        />
                        <LineSeries
                          id="bars"
                          name="0"
                          data={callsByQueueHourly}
                          xAccessor={"x"}
                          yAccessors={["y"]}
                          splitSeriesAccessors={["g"]}
                          curve={CurveType.CURVE_NATURAL}
                        />
                        <Axis
                          title={"Status"}
                          id="bottom-axis"
                          position="bottom"
                        />
                        <Axis
                          title={"Trames"}
                          id="left-axis"
                          position="left"
                          showGridLines
                        />
                      </Chart>
                    )}
                  </div>
                </EuiFlexItem>
                <EuiFlexItem>
                  <div
                    style={{ widht: "100%", height: "18vh", marginTop: "2vh" }}
                  >
                    <EuiIcon type="machineLearningApp" size="l" />
                    &nbsp;&nbsp;
                    <b>AVGs by Trame</b>
                    {avgsByTrameLoading ? (
                      <div style={{ marginTop: "6vh", marginLeft: "50%" }}>
                        <EuiLoadingChart size="m" mono />
                      </div>
                    ) : (
                      <Chart>
                        <Settings
                          showLegend
                          showLegendExtra
                          legendPosition={"right"}
                        />
                        <LineSeries
                          id="bars"
                          name="0"
                          data={avgsByTrame}
                          xAccessor={"x"}
                          yAccessors={["y"]}
                          splitSeriesAccessors={["g"]}
                          curve={CurveType.CURVE_NATURAL}
                        />
                        <Axis
                          title={"Status"}
                          id="bottom-axis"
                          position="bottom"
                        />
                        <Axis
                          title={"Trames"}
                          id="left-axis"
                          position="left"
                          showGridLines
                        />
                      </Chart>
                    )}
                  </div>
                </EuiFlexItem>
                <EuiFlexItem>
                  <div
                    style={{ widht: "100%", height: "18vh", marginTop: "2vh" }}
                  >
                    <EuiIcon type="usersRolesApp" size="l" />
                    &nbsp;&nbsp;
                    <b>Calls by Agent on Queues</b>
                    {callsByAgentLoading ? (
                      <div style={{ marginTop: "6vh", marginLeft: "50%" }}>
                        <EuiLoadingChart size="m" mono />
                      </div>
                    ) : (
                      <Chart>
                        <Settings
                          showLegend
                          showLegendExtra
                          legendPosition={"right"}
                        />
                        <BarSeries
                          id="bars2"
                          xScaleType="ordinal"
                          xAccessor="x"
                          yAccessors={["y"]}
                          stackAccessors={["x"]}
                          splitSeriesAccessors={["g"]}
                          data={callsByAgent}
                        />
                        <Axis
                          title={"Agent"}
                          id="bottom-axis"
                          position="bottom"
                        />
                        <Axis
                          title={"Calls"}
                          id="left-axis"
                          position="left"
                          showGridLines
                        />
                      </Chart>
                    )}
                  </div>
                </EuiFlexItem>
                <EuiFlexItem>
                  <div
                    style={{ widht: "100%", height: "18vh", marginTop: "2vh" }}
                  >
                    <EuiIcon type="usersRolesApp" size="l" />
                    &nbsp;&nbsp;
                    <b>Attended by Agent Global</b>
                    {attendedByAgentLoading ? (
                      <div style={{ marginTop: "6vh", marginLeft: "50%" }}>
                        <EuiLoadingChart size="m" mono />
                      </div>
                    ) : (
                      <Chart>
                        <Settings
                          showLegend
                          showLegendExtra
                          legendPosition={"right"}
                        />
                        <BarSeries
                          id="bars2"
                          name="Attended"
                          xScaleType="ordinal"
                          xAccessor="x"
                          yAccessors={["y"]}
                          data={attendedByAgent}
                        />
                        <Axis
                          title={"Agent"}
                          id="bottom-axis"
                          position="bottom"
                        />
                        <Axis
                          title={"Attended"}
                          id="left-axis"
                          position="left"
                          showGridLines
                        />
                      </Chart>
                    )}
                  </div>
                </EuiFlexItem>
              </EuiFlexGrid>
            </div>
          </Fragment>
        </>
      )}
    </div>
  );
};

export default Dashboard;
